<template>
  <div class="aj-page--full-height">
    <main
      id="main"
      ref="main"
      role="main"
      class="fr-container fr-container--fluid aj-main-container"
      tabindex="-1"
    >
      <slot />
    </main>
  </div>
</template>

<script lang="ts">
import layoutRouteMixin from "@/mixins/layout-route-mixin.js"

export default {
  name: "BaseLayout",
  mixins: [layoutRouteMixin],
}
</script>
